/* Loulou & Co : le panier latéral ne s'ouvre pas après un ajout.
   Le bouton affiche « Ajouté ✓ » et le chiffre du panier se met à jour.
   Le panier s'ouvre seulement quand on touche l'icône. */
(function () {
  var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
  var LABEL = en ? 'Added \u2713' : 'Ajout\u00e9 \u2713';
  var lastBtn = null;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (b) lastBtn = b;
  }, true);

  function markAdded() {
    var b = lastBtn;
    lastBtn = null;
    if (!b) return;
    setTimeout(function () {
      var span = b.querySelector('span:not(.sold-out-message)');
      if (span) span.textContent = LABEL;
      b.classList.add('loulou-ajoute');
      b.setAttribute('disabled', 'disabled');
      b.setAttribute('aria-disabled', 'true');
    }, 50);
  }

  function patch() {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.prototype.__loulouPatched) return;
    CD.prototype.__loulouPatched = true;
    var original = CD.prototype.renderContents;
    CD.prototype.renderContents = function (state) {
      var self = this;
      this.open = function () { delete self.open; };
      try {
        original.call(this, state);
      } catch (err) {
        delete self.open;
        throw err;
      }
      setTimeout(function () {
        if (Object.prototype.hasOwnProperty.call(self, 'open')) delete self.open;
      }, 300);
      markAdded();
    };
  }

  if (window.customElements) customElements.whenDefined('cart-drawer').then(patch);
})();

/* Loulou & Co : message « Plus que X $ pour la livraison gratuite » dans le panier
   (panier latéral et page Panier), avec barre de progression.
   >>> Si le seuil de livraison gratuite change, modifier SEUIL ci-dessous (en cents). <<< */
(function () {
  var SEUIL = 8900; /* 89,00 $ */
  var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return en ? '$' + v : v.replace('.', ',') + '\u00a0$';
  }

  function build(total) {
    if (!total) return '';
    var left = SEUIL - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / SEUIL) * 100)));
    var main = left > 0
      ? (en ? 'Only <strong>' + money(left) + '</strong> more for free shipping' : 'Plus que <strong>' + money(left) + '</strong> pour la livraison gratuite')
      : (en ? 'Your order ships <strong>free</strong>!' : 'Votre commande a droit \u00e0 la <strong>livraison gratuite</strong>\u00a0!');
    return '<p class="loulou-livraison__main">\ud83d\ude9a ' + main + '</p>' +
      '<div class="loulou-livraison__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }

  function targets() {
    var list = [];
    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter) list.push(drawerFooter);
    var pageFooter = document.querySelector('#main-cart-footer .cart__footer') || document.querySelector('.cart__footer');
    if (pageFooter && pageFooter !== drawerFooter) list.push(pageFooter);
    return list;
  }

  function paint(html) {
    targets().forEach(function (footer) {
      var box = footer.querySelector(':scope > .loulou-livraison');
      if (!html) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'loulou-livraison';
        box.setAttribute('role', 'status');
        footer.insertBefore(box, footer.firstChild);
      }
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }

  function update() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(build(c.total_price)); })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 150);
  }

  function watch() {
    var nodes = [document.querySelector('cart-drawer'), document.querySelector('#main-cart-footer'), document.querySelector('cart-items')];
    var obs = new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        var t = m.target;
        return !(t.closest && t.closest('.loulou-livraison'));
      });
      if (relevant) schedule();
    });
    nodes.forEach(function (n) { if (n) obs.observe(n, { childList: true, subtree: true }); });
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) {}
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
